/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateWebhookBody,
  DeleteWebhook200,
  Error,
  GetWebhookDeliveries200,
  GetWebhookDeliveriesParams,
  GetWebhooks200,
  GetWebhooksParams,
  UpdateWebhookBody,
  ValidationError,
  WebhookDelivery,
  WebhookResponse,
  WebhookWithSecret
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Create a webhook endpoint. The response includes the full secret which is only visible on creation and when rotated.
 * @summary Create a new webhook
 */
export type createWebhookResponse201 = {
  data: WebhookWithSecret
  status: 201
}

export type createWebhookResponse400 = {
  data: Error
  status: 400
}

export type createWebhookResponse401 = {
  data: Error
  status: 401
}

export type createWebhookResponse403 = {
  data: Error
  status: 403
}

export type createWebhookResponse404 = {
  data: Error
  status: 404
}

export type createWebhookResponse422 = {
  data: ValidationError
  status: 422
}

export type createWebhookResponse500 = {
  data: Error
  status: 500
}

export type createWebhookResponseSuccess = (createWebhookResponse201) & {
  headers: Headers;
};
export type createWebhookResponseError = (createWebhookResponse400 | createWebhookResponse401 | createWebhookResponse403 | createWebhookResponse404 | createWebhookResponse422 | createWebhookResponse500) & {
  headers: Headers;
};

export type createWebhookResponse = (createWebhookResponseSuccess | createWebhookResponseError)

export const getCreateWebhookUrl = () => {


  

  return `/webhooks`
}

export const createWebhook = async (createWebhookBody: CreateWebhookBody, options?: RequestInit): Promise<createWebhookResponse> => {
  
  return customFetch<createWebhookResponse>(getCreateWebhookUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createWebhookBody,)
  }
);}
  

/**
 * Retrieve a paginated list of webhooks for the entity. Secrets are masked in the response.
 * @summary List all webhooks
 */
export type getWebhooksResponse200 = {
  data: GetWebhooks200
  status: 200
}

export type getWebhooksResponse400 = {
  data: Error
  status: 400
}

export type getWebhooksResponse401 = {
  data: Error
  status: 401
}

export type getWebhooksResponse403 = {
  data: Error
  status: 403
}

export type getWebhooksResponse404 = {
  data: Error
  status: 404
}

export type getWebhooksResponse500 = {
  data: Error
  status: 500
}

export type getWebhooksResponseSuccess = (getWebhooksResponse200) & {
  headers: Headers;
};
export type getWebhooksResponseError = (getWebhooksResponse400 | getWebhooksResponse401 | getWebhooksResponse403 | getWebhooksResponse404 | getWebhooksResponse500) & {
  headers: Headers;
};

export type getWebhooksResponse = (getWebhooksResponseSuccess | getWebhooksResponseError)

export const getGetWebhooksUrl = (params?: GetWebhooksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/webhooks?${stringifiedParams}` : `/webhooks`
}

export const getWebhooks = async (params?: GetWebhooksParams, options?: RequestInit): Promise<getWebhooksResponse> => {
  
  return customFetch<getWebhooksResponse>(getGetWebhooksUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retrieve a single webhook. The secret is masked in the response.
 * @summary Get a webhook by ID
 */
export type getWebhookByIdResponse200 = {
  data: WebhookResponse
  status: 200
}

export type getWebhookByIdResponse401 = {
  data: Error
  status: 401
}

export type getWebhookByIdResponse403 = {
  data: Error
  status: 403
}

export type getWebhookByIdResponse404 = {
  data: Error
  status: 404
}

export type getWebhookByIdResponse500 = {
  data: Error
  status: 500
}

export type getWebhookByIdResponseSuccess = (getWebhookByIdResponse200) & {
  headers: Headers;
};
export type getWebhookByIdResponseError = (getWebhookByIdResponse401 | getWebhookByIdResponse403 | getWebhookByIdResponse404 | getWebhookByIdResponse500) & {
  headers: Headers;
};

export type getWebhookByIdResponse = (getWebhookByIdResponseSuccess | getWebhookByIdResponseError)

export const getGetWebhookByIdUrl = (id: string,) => {


  

  return `/webhooks/${id}`
}

export const getWebhookById = async (id: string, options?: RequestInit): Promise<getWebhookByIdResponse> => {
  
  return customFetch<getWebhookByIdResponse>(getGetWebhookByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update webhook URL, events, active status, or description.
 * @summary Update a webhook
 */
export type updateWebhookResponse200 = {
  data: WebhookResponse
  status: 200
}

export type updateWebhookResponse400 = {
  data: Error
  status: 400
}

export type updateWebhookResponse401 = {
  data: Error
  status: 401
}

export type updateWebhookResponse403 = {
  data: Error
  status: 403
}

export type updateWebhookResponse404 = {
  data: Error
  status: 404
}

export type updateWebhookResponse422 = {
  data: ValidationError
  status: 422
}

export type updateWebhookResponse500 = {
  data: Error
  status: 500
}

export type updateWebhookResponseSuccess = (updateWebhookResponse200) & {
  headers: Headers;
};
export type updateWebhookResponseError = (updateWebhookResponse400 | updateWebhookResponse401 | updateWebhookResponse403 | updateWebhookResponse404 | updateWebhookResponse422 | updateWebhookResponse500) & {
  headers: Headers;
};

export type updateWebhookResponse = (updateWebhookResponseSuccess | updateWebhookResponseError)

export const getUpdateWebhookUrl = (id: string,) => {


  

  return `/webhooks/${id}`
}

export const updateWebhook = async (id: string,
    updateWebhookBody: UpdateWebhookBody, options?: RequestInit): Promise<updateWebhookResponse> => {
  
  return customFetch<updateWebhookResponse>(getUpdateWebhookUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateWebhookBody,)
  }
);}
  

/**
 * Permanently delete a webhook endpoint. Pending deliveries will be cancelled.
 * @summary Delete a webhook
 */
export type deleteWebhookResponse200 = {
  data: DeleteWebhook200
  status: 200
}

export type deleteWebhookResponse400 = {
  data: Error
  status: 400
}

export type deleteWebhookResponse401 = {
  data: Error
  status: 401
}

export type deleteWebhookResponse403 = {
  data: Error
  status: 403
}

export type deleteWebhookResponse404 = {
  data: Error
  status: 404
}

export type deleteWebhookResponse422 = {
  data: ValidationError
  status: 422
}

export type deleteWebhookResponse500 = {
  data: Error
  status: 500
}

export type deleteWebhookResponseSuccess = (deleteWebhookResponse200) & {
  headers: Headers;
};
export type deleteWebhookResponseError = (deleteWebhookResponse400 | deleteWebhookResponse401 | deleteWebhookResponse403 | deleteWebhookResponse404 | deleteWebhookResponse422 | deleteWebhookResponse500) & {
  headers: Headers;
};

export type deleteWebhookResponse = (deleteWebhookResponseSuccess | deleteWebhookResponseError)

export const getDeleteWebhookUrl = (id: string,) => {


  

  return `/webhooks/${id}`
}

export const deleteWebhook = async (id: string, options?: RequestInit): Promise<deleteWebhookResponse> => {
  
  return customFetch<deleteWebhookResponse>(getDeleteWebhookUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Send a test event to the webhook endpoint to verify connectivity.
 * @summary Test a webhook
 */
export type testWebhookResponse200 = {
  data: WebhookDelivery
  status: 200
}

export type testWebhookResponse400 = {
  data: Error
  status: 400
}

export type testWebhookResponse401 = {
  data: Error
  status: 401
}

export type testWebhookResponse403 = {
  data: Error
  status: 403
}

export type testWebhookResponse404 = {
  data: Error
  status: 404
}

export type testWebhookResponse422 = {
  data: ValidationError
  status: 422
}

export type testWebhookResponse500 = {
  data: Error
  status: 500
}

export type testWebhookResponseSuccess = (testWebhookResponse200) & {
  headers: Headers;
};
export type testWebhookResponseError = (testWebhookResponse400 | testWebhookResponse401 | testWebhookResponse403 | testWebhookResponse404 | testWebhookResponse422 | testWebhookResponse500) & {
  headers: Headers;
};

export type testWebhookResponse = (testWebhookResponseSuccess | testWebhookResponseError)

export const getTestWebhookUrl = (id: string,) => {


  

  return `/webhooks/${id}/test`
}

export const testWebhook = async (id: string, options?: RequestInit): Promise<testWebhookResponse> => {
  
  return customFetch<testWebhookResponse>(getTestWebhookUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Retrieve a paginated list of delivery attempts for a specific webhook.
 * @summary List webhook deliveries
 */
export type getWebhookDeliveriesResponse200 = {
  data: GetWebhookDeliveries200
  status: 200
}

export type getWebhookDeliveriesResponse400 = {
  data: Error
  status: 400
}

export type getWebhookDeliveriesResponse401 = {
  data: Error
  status: 401
}

export type getWebhookDeliveriesResponse403 = {
  data: Error
  status: 403
}

export type getWebhookDeliveriesResponse404 = {
  data: Error
  status: 404
}

export type getWebhookDeliveriesResponse500 = {
  data: Error
  status: 500
}

export type getWebhookDeliveriesResponseSuccess = (getWebhookDeliveriesResponse200) & {
  headers: Headers;
};
export type getWebhookDeliveriesResponseError = (getWebhookDeliveriesResponse400 | getWebhookDeliveriesResponse401 | getWebhookDeliveriesResponse403 | getWebhookDeliveriesResponse404 | getWebhookDeliveriesResponse500) & {
  headers: Headers;
};

export type getWebhookDeliveriesResponse = (getWebhookDeliveriesResponseSuccess | getWebhookDeliveriesResponseError)

export const getGetWebhookDeliveriesUrl = (id: string,
    params?: GetWebhookDeliveriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/webhooks/${id}/deliveries?${stringifiedParams}` : `/webhooks/${id}/deliveries`
}

export const getWebhookDeliveries = async (id: string,
    params?: GetWebhookDeliveriesParams, options?: RequestInit): Promise<getWebhookDeliveriesResponse> => {
  
  return customFetch<getWebhookDeliveriesResponse>(getGetWebhookDeliveriesUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Generate a new signing secret for the webhook. The previous secret is immediately invalidated.
 * @summary Rotate webhook secret
 */
export type rotateWebhookSecretResponse200 = {
  data: WebhookWithSecret
  status: 200
}

export type rotateWebhookSecretResponse400 = {
  data: Error
  status: 400
}

export type rotateWebhookSecretResponse401 = {
  data: Error
  status: 401
}

export type rotateWebhookSecretResponse403 = {
  data: Error
  status: 403
}

export type rotateWebhookSecretResponse404 = {
  data: Error
  status: 404
}

export type rotateWebhookSecretResponse422 = {
  data: ValidationError
  status: 422
}

export type rotateWebhookSecretResponse500 = {
  data: Error
  status: 500
}

export type rotateWebhookSecretResponseSuccess = (rotateWebhookSecretResponse200) & {
  headers: Headers;
};
export type rotateWebhookSecretResponseError = (rotateWebhookSecretResponse400 | rotateWebhookSecretResponse401 | rotateWebhookSecretResponse403 | rotateWebhookSecretResponse404 | rotateWebhookSecretResponse422 | rotateWebhookSecretResponse500) & {
  headers: Headers;
};

export type rotateWebhookSecretResponse = (rotateWebhookSecretResponseSuccess | rotateWebhookSecretResponseError)

export const getRotateWebhookSecretUrl = (id: string,) => {


  

  return `/webhooks/${id}/rotate-secret`
}

export const rotateWebhookSecret = async (id: string, options?: RequestInit): Promise<rotateWebhookSecretResponse> => {
  
  return customFetch<rotateWebhookSecretResponse>(getRotateWebhookSecretUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

